<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_button_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-row">
            <div class="form-group mb-20" [class.has-error]="isEmptyLabel()">
                <label class="col-xs-12">
                    {{ "control_text" | translate }}
                </label>
                <div class="col-xs-12">
                    <input class="form-control" [value]="label()" (input)="onLabelChange($event)" />
                    @if (isEmptyLabel()) {
                        <span class="help-block small">
                            {{ "control_errors_required" | translate }}
                        </span>
                    }
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ LINK_TYPE_NAME[linkType()] | translate }}
                </label>
                <div class="col-xs-12 input-group">
                    <div class="input-group-btn type-dropdown" dropdown>
                        <button dropdownToggle type="button" class="btn btn-default type-dropdown-toggle">
                            <img
                                class="element-icon mr-10"
                                src="./assets/img/websites/forms-icons/lpc-f-{{ linkType() }}-icon.svg"
                                alt="url-icon"
                            />
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu" *dropdownMenu>
                            @for (option of LINK_TYPES; track option.type) {
                                <li [class.selected]="option.type === linkType()" (click)="setLinkType(option)">
                                    <a>
                                        <span class="dropdown-icon mr-10">
                                            <img
                                                src="./assets/img/websites/forms-icons/lpc-f-{{ option.type }}-icon.svg"
                                                [alt]="option.type"
                                            />
                                        </span>
                                        {{ option.name | translate }}
                                    </a>
                                </li>
                            }
                        </ul>
                    </div>
                    <input
                        class="form-control"
                        [placeholder]="BUTTON_LINK_TYPE_PLACEHOLDER[linkType()]"
                        [value]="linkUrl()"
                        (input)="onLinkUrlChange($event)"
                    />
                </div>
            </div>

            <div class="form-group mb-20 form-horizontal row">
                <label class="control-label col-xs-9">
                    {{ "control_target" | translate }}
                </label>
                <div class="col-xs-3 control-switch text-right">
                    <sp-switch [active]="isTargetBlank()" (toggleActiveEvent)="toggleTargetBlank($event)" />
                </div>
            </div>

            <div class="form-group">
                <label class="col-xs-12">
                    {{ "control_style" | translate }}
                </label>
                <div class="col-xs-6">
                    <select class="form-control" (change)="onStyleTypeChange($event)">
                        <option
                            [value]="EButtonStyleType.primary"
                            [selected]="styleType() === EButtonStyleType.primary"
                        >
                            {{ "control_appearance_primary" | translate }}
                        </option>
                        <option
                            [value]="EButtonStyleType.secondary"
                            [selected]="styleType() === EButtonStyleType.secondary"
                        >
                            {{ "control_appearance_secondary" | translate }}
                        </option>
                        <option [value]="EButtonStyleType.custom" [selected]="styleType() === EButtonStyleType.custom">
                            {{ "control_appearance_custom" | translate }}
                        </option>
                    </select>
                </div>
                <div class="col-xs-6">
                    <div class="btn-group d-flex">
                        <sp-radio-group
                            [selected]="size()"
                            [type]="ERadioGroupType.size"
                            (changeSelectedEvent)="setSize($event)"
                        />
                    </div>
                </div>
            </div>

            @if (isCustomStyle()) {
                <web-custom-button
                    [isIndependentCorners]="isIndependentCorners()"
                    [radiusSettings]="$any(advancedRadius())"
                    [isAdvancedRadius]="true"
                    [parentBase]="buttonBase()"
                    [parentHover]="buttonHover()"
                    (valueChangeEvent)="customButtonChangeHandler($event)"
                />
            }
        </div>
    </div>
</div>

<web-settings-footer [isSaveDisabled]="isEmptyLabel()" (saveEvent)="onSave()" (cancelEvent)="onReset()" />
